import { ListItem, ListItemText } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { EventMapItem } from "../types/mapItems";

const useStyles = makeStyles((theme) => ({
  divider: {
    borderBottomColor: theme.palette.primary.light,
  },
}));

interface Props {
  event: EventMapItem;
  style: React.CSSProperties;
  onClick: (p: EventMapItem) => void;
}

const EventListItem = ({ event, style, onClick }: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <ListItem
      button
      divider
      classes={{ divider: classes.divider }}
      style={style}
      onClick={() => onClick(event)}
    >
      <ListItemText
        primary={event.name}
        primaryTypographyProps={{ noWrap: true, title: event.name }}
        secondaryTypographyProps={{
          color: "inherit",
          noWrap: true,
          title: event.eventType?.name ?? "",
        }}
        secondary={event.eventType?.name ?? ""}
      />
    </ListItem>
  );
};

export default EventListItem;
